module.exports = __webpack_public_path__ + "static/media/Logo__Stickermule_white.3eea4a66.svg";